/* HF x Lymphoria page behaviour. One URL, two layouts: [data-hl-root="phone"] (under 1024px) and [data-hl-root="desktop"].
   Offer data: Shopify section JSON ([data-hl-data]) when live, window.HL_OFFER in local previews.
   Checkout: one server-side navigation chain, as on /pages/anxious-dog-offer:
   /cart/clear -> /cart/update (attributes) -> /cart/add (pack + selling plan + gifts) -> /discount/CODE -> /checkout */
(function () {
  var doc = document;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var money = function (v) { return '$' + v.toFixed(2); };
  var dl = window.dataLayer = window.dataLayer || [];
  var FUNNEL = 'hf-bundle-offer';
  var PAGE = location.pathname;

  // ---------- offer data ----------
  var D = window.HL_OFFER || null;
  var dataEl = $('[data-hl-data]');
  if (dataEl) { try { D = JSON.parse(dataEl.textContent); } catch (e) { D = null; } }
  D = D || {};
  if (D.static) Object.keys(D.static).forEach(function (k) { if (D[k] == null) D[k] = D.static[k]; });
  var OFFER = !!(D.packs && D.packs['1'] && D.packs['3'] && D.packs['5']);   // real product data: needed for checkout
  if (!OFFER) {   // product missing or unpublished: run the buy box on the printed design prices, checkout stays off
    dl.push({ event: 'po_offer_checkout_error', funnel: FUNNEL, message: 'offer data missing' });
    D.packs = JSON.parse(JSON.stringify(D.fallback || {}));
  }
  var PRICED = !!(D.packs && D.packs['1'] && D.packs['3'] && D.packs['5']);
  // packs: one-time price, subscribe price (selling plan allocation), struck prices
  var base = PRICED ? D.packs['1'].one : 0;
  if (PRICED) Object.keys(D.packs).forEach(function (k) {
    var p = D.packs[k];
    var plan = D.plans && D.plans[k];
    if (p.subs && plan && p.subs[plan] != null) p.sub = p.subs[plan];
    if (p.sub == null) p.sub = Math.round(p.one * (100 - (D.subPct || 20))) / 100;
    p.one_struck = Math.round(base * p.bottles * 100) / 100;
  });
  var state = { pack: D.def || '3', mode: 'one' };

  // ---------- countdown: a 2-hour window per visitor that restarts (as on the reference) ----------
  function cdEnd() {
    var k = 'hl_cd_end', now = Date.now(), end = 0;
    try { end = +localStorage.getItem(k) || 0; } catch (e) {}
    if (end < now) { end = now + 2 * 3600 * 1000 - 18 * 1000; try { localStorage.setItem(k, end); } catch (e) {} }
    return end;
  }
  var END = cdEnd();
  function tick() {
    var d = END - Date.now(); if (d <= 0) { END = cdEnd(); d = END - Date.now(); }
    var v = { h: Math.floor(d / 3600000), m: Math.floor(d / 60000) % 60, s: Math.floor(d / 1000) % 60 };
    $$('[data-cd]').forEach(function (el) { el.textContent = String(v[el.getAttribute('data-cd')]).padStart(2, '0'); });
  }
  tick(); setInterval(tick, 1000);

  // ---------- arrival date: today + 7 days, off Sundays ----------
  (function () {
    var d = new Date(); d.setDate(d.getDate() + 7); if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    var n = d.getDate(), suf = (n % 10 === 1 && n !== 11) ? 'st' : (n % 10 === 2 && n !== 12) ? 'nd' : (n % 10 === 3 && n !== 13) ? 'rd' : 'th';
    var t = d.toLocaleDateString('en-US', { month: 'long' }) + ' ' + n + suf;
    $$('[data-arrive]').forEach(function (el) { el.textContent = t; });
  })();

  // ---------- render ----------
  var roots = $$('[data-hl-root]');
  function modeOf(root) { return root.getAttribute('data-hl-root') === 'phone' ? 'sub' : state.mode; }
  // what a pack saves against the same number of single bottles on the same plan (the nudge amounts)
  function saveVsSingles(k, mode) {
    var a = D.packs['1'], q = D.packs[k];
    return Math.max(0, Math.round(((mode === 'sub' ? a.sub : a.one) * q.bottles - (mode === 'sub' ? q.sub : q.one)) * 100) / 100);
  }
  function render() {
    if (!PRICED) return;
    var a1 = D.packs['1'], pct = a1.one ? Math.round((1 - a1.sub / a1.one) * 100) : 0;
    if (pct > 0) $$('[data-sublabel]').forEach(function (el) { el.textContent = 'Subscribe & Save ' + pct + '%'; });
    var p = D.packs[state.pack];
    roots.forEach(function (root) {
      var mode = modeOf(root);
      $$('[data-pack]', root).forEach(function (c) {
        var k = c.getAttribute('data-pack'), q = D.packs[k], on = k === state.pack;
        c.classList.toggle('is-active', on); c.setAttribute('aria-checked', on ? 'true' : 'false');
        var now = mode === 'sub' ? q.sub : q.one, was = q.one_struck;
        $$('[data-now]', c).forEach(function (el) { el.textContent = money(now); });
        $$('[data-was]', c).forEach(function (el) { el.textContent = was > now ? money(was) : ''; });
        $$('[data-save]', c).forEach(function (el) { el.textContent = money(Math.max(0, was - now)); var row = el.closest('.hd-card__save'); if (row) row.hidden = !(was - now > 0.004); });
        $$('[data-per]', c).forEach(function (el) { el.textContent = money(Math.round(now / q.bottles * 100) / 100) + ' per Bottle'; });
      });
      var now = mode === 'sub' ? p.sub : p.one, was = p.one_struck;
      $$('[data-atc-now]', root).forEach(function (el) { el.textContent = money(now); });
      $$('[data-atc-was]', root).forEach(function (el) { el.textContent = was > now ? money(was) : ''; });
      $$('.hl-nudge', root).forEach(function (n) {
        var x = D.nudge[state.pack]; $('.hl-nudge__title', n).textContent = x[0];
        $('.hl-nudge__text', n).innerHTML = x[1].replace('{save3}', money(saveVsSingles('3', mode))).replace('{save5}', money(saveVsSingles('5', mode)));
        n.setAttribute('data-up', state.pack === '1' ? '1' : '0');
      });
      $$('[data-refill]', root).forEach(function (el) { el.textContent = 'Refills Ship ' + D.every[state.pack]; });
      $$('[data-weeks]', root).forEach(function (el) { el.textContent = 'Delivery ' + D.every[state.pack].toLowerCase() + '. Cancel anytime!'; });
      $$('[data-mode]', root).forEach(function (b) { var on = b.getAttribute('data-mode') === state.mode; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    });
  }

  // ---------- checkout ----------
  var busy = false;
  (function guard() { // while checking out, drop cart writes from other scripts (Intelligems' gift-with-purchase)
    var isMut = function (u) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(u || '')); };
    var of = window.fetch;
    if (of) window.fetch = function (input, init) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      if (busy && isMut(u)) { dl.push({ event: 'po_offer_cart_guard', funnel: FUNNEL, url: String(u).slice(0, 80) }); return Promise.resolve(new Response('{"items":[],"item_count":0}', { status: 200, headers: { 'Content-Type': 'application/json' } })); }
      return of.apply(this, arguments);
    };
    var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__hlUrl = u; return oo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () { if (busy && isMut(this.__hlUrl)) { dl.push({ event: 'po_offer_cart_guard', funnel: FUNNEL, url: String(this.__hlUrl).slice(0, 80) }); return; } return os.apply(this, arguments); };
  })();
  function checkout(root, origin) {
    if (busy) return;
    if (!OFFER) { alert('Sorry, this offer is not available right now. Please try again shortly.'); return; }
    var mode = modeOf(root), p = D.packs[state.pack];
    var plan = mode === 'sub' ? D.plans[state.pack] : '';
    if (!p || !p.id || (mode === 'sub' && !plan)) { dl.push({ event: 'po_offer_checkout_error', funnel: FUNNEL, message: 'missing variant or plan ' + state.pack }); alert('Sorry, this option is not available right now. Please pick another pack.'); return; }
    var gifts = [];
    if (D.gifts.bundle) gifts.push(D.gifts.bundle);
    if (p.bottles >= 3 && D.gifts.primal) gifts.push(D.gifts.primal);
    var attrs = { funnel: FUNNEL, landing_page: PAGE, offer_layout: root.getAttribute('data-hl-root'), offer_pack: p.label, offer_bottles: String(p.bottles), offer_mode: mode === 'sub' ? 'sub' : 'once' };
    if (p.bottles >= 5 && D.gifts.voucher) attrs.offer_voucher = D.gifts.voucher;
    var incoming = new URLSearchParams(location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'].forEach(function (k) { if (incoming.get(k)) attrs[k] = incoming.get(k); });
    if (incoming.get('funnel') && incoming.get('funnel') !== FUNNEL) attrs.entry_funnel = incoming.get('funnel');
    var gos = window.GrowthOS && window.GrowthOS.get ? window.GrowthOS.get() : null;
    if (gos && gos.shot_id) { attrs.shot_id = gos.shot_id; attrs.chain_variant = gos.chain_variant || ''; attrs.step_variant = gos.step_variant || ''; attrs.first_touch_ts = gos.first_touch_ts || ''; }
    busy = true; if (origin) origin.classList.add('is-busy');
    dl.push({ event: 'po_offer_checkout', funnel: FUNNEL, layout: attrs.offer_layout, pack: p.label, bottles: p.bottles, mode: attrs.offer_mode, value: mode === 'sub' ? p.sub : p.one, currency: 'USD' });
    if (!dataEl) { busy = false; if (origin) setTimeout(function () { origin.classList.remove('is-busy'); }, 600); return; } // local preview: no cart
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; })
      .then(function (cart) {
        var ig = cart && cart.attributes && cart.attributes.igOffers ? String(cart.attributes.igOffers).split(',')[0] : '';
        var qs = new URLSearchParams(), n = 0;
        var add = function (id, qty, sp, props) {
          qs.append('items[' + n + '][id]', String(id)); qs.append('items[' + n + '][quantity]', String(qty));
          if (sp) qs.append('items[' + n + '][selling_plan]', String(sp));
          Object.keys(props || {}).forEach(function (k) { qs.append('items[' + n + '][properties][' + k + ']', props[k]); });
          n++;
        };
        add(p.id, 1, plan, null);
        gifts.forEach(function (id) { add(id, 1, '', String(id) === String(D.gifts.bundle) && ig ? { _igGWP: ig, _igGWPTier: '0' } : null); });
        var attrStep = function (next) { var u = new URLSearchParams(); Object.keys(attrs).forEach(function (k) { u.append('attributes[' + k + ']', attrs[k]); }); u.append('return_to', next); return '/cart/update?' + u.toString(); };
        var dest = D.shipCode ? '/discount/' + encodeURIComponent(D.shipCode) + '?redirect=/checkout' : '/checkout';
        qs.append('return_to', attrStep(dest));
        location.href = '/cart/clear?return_to=' + encodeURIComponent(attrStep('/cart/add?' + qs.toString()));
      })
      .catch(function (err) { busy = false; if (origin) origin.classList.remove('is-busy'); dl.push({ event: 'po_offer_checkout_error', funnel: FUNNEL, message: String(err && err.message || err) }); });
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) { busy = false; $$('.is-busy').forEach(function (b) { b.classList.remove('is-busy'); }); } });

  // ---------- clicks ----------
  doc.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null; if (!t) return;
    var b, root = t.closest('[data-hl-root]');
    if ((b = t.closest('[data-pack]'))) { state.pack = b.getAttribute('data-pack'); render(); dl.push({ event: 'po_offer_option', funnel: FUNNEL, pack: state.pack }); return; }
    if (t.closest('.hl-nudge[data-up="1"]')) { state.pack = '3'; render(); return; }
    if ((b = t.closest('[data-mode]'))) { state.mode = b.getAttribute('data-mode'); render(); dl.push({ event: 'po_offer_option', funnel: FUNNEL, mode: state.mode }); return; }
    if ((b = t.closest('[data-atc]')) && root) { e.preventDefault(); checkout(root, b); return; }
  });
  render();

  // ---------- galleries ----------
  $$('.hl-gallery, .hd-gallery').forEach(function (g) {
    g.addEventListener('click', function (e) {
      var t = e.target.closest('button[data-slide]'); if (!t) return;
      var i = t.getAttribute('data-slide');
      $$('[data-slide]', g).forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-slide') === i); });
    });
  });

  // ---------- sliders: toggled items, or a sliding track ----------
  $$('[data-slider]').forEach(function (s) {
    var track = $('.hl-rss__track, .hl-tf__track, .hd-track', s);
    var items = track ? $$(':scope > *', track) : $$(':scope > .hl-rslide, :scope > .hl-rc, :scope > .hl-step', s);
    if (!items.length) return;
    var i = Math.max(0, items.findIndex(function (x) { return x.classList.contains('is-active'); }));
    var dots = $$('.hl-dots i', s);
    function go(k) {
      i = (k + items.length) % items.length;
      if (track) {
        var off = items[i].offsetLeft - items[0].offsetLeft - (track.classList.contains('hl-tf__track') ? (s.clientWidth - items[i].offsetWidth) / 2 - items[0].offsetLeft : 0);
        track.style.transform = 'translateX(' + (-off) + 'px)';
      } else items.forEach(function (x, j) { x.classList.toggle('is-active', j === i); });
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
    }
    s.addEventListener('click', function (e) { if (e.target.closest('[data-prev]')) go(i - 1); if (e.target.closest('[data-next]')) go(i + 1); });
    if (track) { go(i); window.addEventListener('resize', function () { go(i); }); }
  });

  // ---------- tabs ----------
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-tab]');
    if (b) { var t = b.closest('[data-tabs]'); $$('[data-tab]', t).forEach(function (x) { x.classList.toggle('is-active', x === b); }); $$('[data-panel]', t).forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === b.getAttribute('data-tab')); }); return; }
    var r = e.target.closest && e.target.closest('[data-rtab]');
    if (r) { var sec = r.closest('section'); $$('[data-rtab]', sec).forEach(function (x) { x.classList.toggle('is-active', x === r); }); $$('[data-rpanel]', sec).forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-rpanel') === r.getAttribute('data-rtab')); }); }
  });

  // ---------- sticky bars: after the first Add To Cart leaves the screen, hidden while any buy button is on screen ----------
  roots.forEach(function (root) {
    var sticky = $('[data-sticky]', root), atcs = $$('[data-atc]', root);
    if (!sticky || !atcs.length || !('IntersectionObserver' in window)) return;
    var seen = new Set();
    var upd = function () { var past = atcs[0].getBoundingClientRect().bottom < 0 && root.offsetParent !== null; sticky.classList.toggle('is-on', past && seen.size === 0); };
    var io = new IntersectionObserver(function (es) { es.forEach(function (x) { if (x.isIntersecting) seen.add(x.target); else seen.delete(x.target); }); upd(); });
    atcs.forEach(function (a) { io.observe(a); });
    window.addEventListener('scroll', upd, { passive: true });
  });

  // ---------- "What's Inside" popup ----------
  doc.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var m = $('[data-modal]');
    if (m && t.closest('[data-modal-open]')) m.hidden = false;
    if (m && t.closest('[data-modal-close]')) m.hidden = true;
  });
  doc.addEventListener('keydown', function (e) { var m = $('[data-modal]'); if (e.key === 'Escape' && m) m.hidden = true; });

  // ---------- section views ----------
  if ('IntersectionObserver' in window) {
    var seenS = {};
    var sio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var id = en.target.getAttribute('data-hl-section'); if (!en.isIntersecting || seenS[id] || en.target.offsetParent === null) return;
        seenS[id] = true; dl.push({ event: 'po_offer_section_view', funnel: FUNNEL, section: id }); sio.unobserve(en.target);
      });
    }, { threshold: 0.5 });
    $$('[data-hl-section]').forEach(function (s) { sio.observe(s); });
  }
})();
